import { render } from "./SubscriptionPlans.vue?vue&type=template&id=366a40d8&scoped=true"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js"

import "./SubscriptionPlans.vue?vue&type=style&index=0&id=366a40d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366a40d8"]])

export default __exports__